import { ActionButton, RegularButton } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import React from "react";
import styles from "./FindingButtons.module.sass";
import AuditNoteCloseButton from "../CustomCells/PushAuditNote/AuditNoteCloseButton";

const FindingButton = (props) => {
    const {
        hideDetailButton = true,
        projectId,
        fiscalYear,
        importId,
        ruleId,
        modulePrefix,
        origin,
        entityName,
        entityId,
        title,
        checkList,
    } = props;

    const findingsList = (checkList || [])
        .filter((elem) => elem.checked !== false)
        .map((x) => x.id);

    const { pushDialog, getFindingDetails, pushModal, reload, i18n } = useGlobalValue();

    const data = {
        projectId,
        fiscalYear,
        importId,
        ruleId,
        findingsList: findingsList && findingsList.length ? findingsList.join(", ") : undefined,
    };
    return (
        <div>
            <h3 className={styles["title"]}>{title}</h3>
            <div className={`${styles["finding-buttons"]}`}>
                <div className={`${styles["finding-button"]}`}>
                    <RegularButton
                        onClick={() => {
                            pushModal({
                                title: "Audit notes for Findings",
                                data: { ...data },
                                args: {
                                    id:
                                        findingsList && findingsList.length === 1
                                            ? findingsList[0]
                                            : ruleId,
                                    projectId,
                                    fiscalYear,
                                    importId,
                                    modulePrefix,
                                    origin: findingsList && findingsList.length ? "F" : origin,
                                    entityName,
                                    entityId,
                                    findingsList: findingsList.join(", "),
                                    findingId:
                                        findingsList && findingsList.length
                                            ? findingsList.length === 1
                                                ? findingsList[0]
                                                : findingsList.join(", ")
                                            : ruleId,
                                    showAuditNoteHistory:
                                        findingsList && findingsList.length > 1 ? false : true,
                                },
                                view: "AuditNotesForm",
                                modalType: "audit",
                                customHeaderButton: AuditNoteCloseButton,
                            })
                                .then(() => reload && reload())
                                .catch(() => null);
                        }}
                    >
                        {i18n`Audit Note`}
                    </RegularButton>
                </div>
                {hideDetailButton || ruleId === "0" ? null : (
                    <div className={`${styles["finding-button"]}`}>
                        <ActionButton
                            primary
                            onClick={() => {
                                pushDialog &&
                                    pushDialog("ConfirmDialog", i18n`Rule Execution`, {
                                        title: i18n`Do you want to see all findings for this rule?`,
                                        promptText: i18n`Please confirm that you want to proceed!`,
                                    }).then(() => {
                                        getFindingDetails(
                                            projectId,
                                            fiscalYear,
                                            modulePrefix,
                                            ruleId,
                                            importId,
                                        ).then((res) => res && window.location.reload());
                                    });
                            }}
                        >
                            {i18n`Show all errors`}
                        </ActionButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FindingButton;
